import { useState, useCallback } from "react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useReportPdf(reportId, companyName) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const download = useCallback(() => {
    setDownloading(true);
    setError(null);
    toast.info("Generating PDF...", { duration: 2000 });

    const xhr = new XMLHttpRequest();
    xhr.open("GET", `${API}/reports/${reportId}/pdf`);
    xhr.responseType = "blob";
    xhr.timeout = 30000;

    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        const msg = "Failed to download PDF";
        setError(msg);
        toast.error(msg, { duration: 5000 });
        setDownloading(false);
        return;
      }
      const blob = xhr.response;
      if (!blob || blob.size === 0) {
        const msg = "PDF file is empty";
        setError(msg);
        toast.error(msg, { duration: 5000 });
        setDownloading(false);
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const filename = `${(companyName || "brand").replace(/\s+/g, "_")}_strategy.pdf`;
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
      toast.success("PDF downloaded successfully!", { duration: 3000 });
      setDownloading(false);
    };

    xhr.onerror = () => {
      const msg = "Download failed. Please try again.";
      setError(msg);
      toast.error(msg, { duration: 5000 });
      setDownloading(false);
    };

    xhr.ontimeout = () => {
      const msg = "Download timed out. Please try again.";
      setError(msg);
      toast.error(msg, { duration: 5000 });
      setDownloading(false);
    };

    xhr.send();
  }, [reportId, companyName]);

  return { downloading, error, download };
}
